<template>
  <div>
    <div
      class="taskbar"
      :style="{
        border: isLayoutSet ? '1px dashed #2587FF' : '1px solid #d9d9d9',
      }"
    >
      <div class="taskbar_header flex">
        <div class="title">
          <eui-icon icon="eicon-cgrw" color="#333" font-size="18px" />
          <div class="text">采购业务</div>
        </div>
        <el-popover
          ref="popover"
          :offset="-120"
          placement="bottom"
          width="300"
          trigger="click"
          popper-class="taskbar_popover"
        >
          <div>
            <p class="popover_title">快捷显示</p>
            <div class="checkList">
              <div
                v-for="(item, index) in taskBarMenuList"
                :key="index"
                class="checkList_item"
              >
                <el-checkbox v-model="item.checked" :disabled="item.disabled">
                  {{ item.name }}
                </el-checkbox>
              </div>
            </div>
          </div>
          <div slot="reference" class="date flex">
            <img
              src="@/assets/img/workbench/taskbar.png"
              height="16px"
              alt=""
            />
          </div>
        </el-popover>
      </div>
      <div class="task_menu flex">
        <div v-for="(item, index) in taskBarMenuList" :key="index">
          <div v-if="item.checked" class="task_item" @click="toPath(item, 1)">
            <div class="task_icon">
              <img :src="item.icon" height="22px" alt="" />
            </div>
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
      <div class="task_data flex">
        <div
          v-for="(item, index) in finalData"
          :key="index"
          :class="index + 1 == finalData.length ? 'item_end' : 'data_item'"
        >
          <p class="task_title">{{ item.name }}</p>
          <div class="flex">
            <div
              v-for="(item1, index1) in item.chidrenData"
              :key="index1"
              class="task_data_item"
              :class="
                index1 + 1 == item.chidrenData.length
                  ? 'task_data_item_end'
                  : 'task_data_item_box'
              "
            >
              <div v-show="item1.desc" class="task_desc">
                {{ item1.desc }}
                <el-tooltip
                  v-show="item1.desc === '异常订单'"
                  class="item"
                  effect="dark"
                  placement="top-end"
                >
                  <div slot="content">
                    平台系统识别出需要向采购方再<br />次核实的订单（包括但不限于：<br />供需双方存在产品互供、订单金<br />额异常、订单周期异常等情况）
                  </div>
                  <i class="el-icon-question" />
                </el-tooltip>
              </div>
              <p
                v-for="(item2, index2) in item1.list"
                :key="index2"
                class="task_list"
              >
                <span class="name" :style="{ width: item1.width }"
                  >{{ item2.name }}:</span
                >
                <span
                  v-if="!item2.money"
                  :class="item2.count ? 'count' : 'count_none'"
                  @click="toPath(item2, 2)"
                >
                  {{ item2.count > 99 ? '99+' : item2.count }}
                </span>

                <el-tooltip
                  v-else
                  class="item"
                  effect="dark"
                  placement="top-start"
                >
                  <div slot="content">
                    <div>待下单数: {{ item2.count }}</div>
                    <br />
                    <div>待下单金额: {{ item2.money }}</div>
                  </div>
                  <span
                    :class="item2.count ? 'count' : 'count_none'"
                    @click="toPath(item2, 2)"
                  >
                    {{ item2.count }}
                  </span>
                </el-tooltip>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/dataCenter';
import api_authority from '@/modules/projectA/api/authority';
import {
  epecMallUrl,
  callBackUrl,
  bidSysBaseUrl,
  purchaseUrl,
  yyhtUrl,
  bidDingUrl,
  oldMallBaseUrl,
} from '@/modules/projectA/api/config';
import whiteUtils from '../../../../utils/isNanJingWhite';

export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    isLayoutSet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      taskMenuList: [
        {
          name: '基础信息',
          icon: require('@/assets/img/workbench/基础信息.png'),
          path: `${purchaseUrl}/user/user/companyInfo`,
          authCode: '/user/user/companyInfo',
          disabled: true,
          checked: true,
        },
        {
          name: '预算管理',
          icon: require('@/assets/img/workbench/预算管理.png'),
          path: `${purchaseUrl}/user/user/budgetManagement`,
          authCode: '/user/user/budgetManagement',
          disabled: true,
          checked: true,
        },
        {
          name: '需求计划管理',
          icon: require('@/assets/img/workbench/需求计划管理.png'),
          path: `${callBackUrl}/demand/demandManage`,
          authCode: '/demand/demandManage',
          disabled: true,
          checked: true,
        },
        {
          name: '采购计划',
          icon: require('@/assets/img/workbench/采购方式.png'),
          path: `${callBackUrl}/plan/purchaseWayEdit`,
          authCode: '/plan/purchaseWayEdit',
          checked: true,
        },
        {
          name: '询价管理',
          icon: require('@/assets/img/workbench/询价管理.png'),
          path: `${callBackUrl}/enquiryManage/enquiry`,
          authCode: '/enquiryManage/enquiry',
          disabled: true,
          checked: true,
        },
        {
          name: '招标管理',
          icon: require('@/assets/img/workbench/招标管理.png'),
          path: `${bidSysBaseUrl}/#/bidding/preparationScheme`,
          authCode: '/bidding/preparationScheme',
          disabled: true,
          checked: true,
        },
        {
          name: '委托招标',
          icon: require('@/assets/img/workbench/委托招标.png'),
          // path: ``,
          // authCode: '',
          path: `${oldMallBaseUrl}/ecmall/externalLogin/loginPlatform.do?referer=${bidDingUrl}`,
          authCode: `${oldMallBaseUrl}/ecmall/externalLogin/loginPlatform.do?referer=${bidDingUrl}`,
          disabled: true,
          checked: true,
        },
        {
          name: '协议管理',
          icon: require('@/assets/img/workbench/协议管理.png'),
          // path: `${yyhtUrl}/#/agreementManage`,
          authCode: 'https://yyzx.epec.com/#/agreementManage',
          disabled: true,
          checked: true,
        },
        {
          name: '常采物资',
          icon: require('@/assets/img/workbench/常采物资.png'),
          path: `${purchaseUrl}/purchaseRecord`,
          authCode: '/purchaseRecord',
          disabled: true,
          checked: true,
        },
        {
          name: '供应商资源',
          icon: require('@/assets/img/workbench/供应商资源.png'),
          // path: `${yyhtUrl}/#/supplierManagement`,
          authCode: 'https://yyzx.epec.com/#/supplierManagement',
          disabled: true,
          checked: true,
        },
        {
          name: '订单管理',
          icon: require('@/assets/img/workbench/订单管理.png'),
          path: `${purchaseUrl}/user/user/userOrder`,
          authCode: '/user/user/userOrder',
          disabled: true,
          checked: true,
        },
        {
          name: '审批管理',
          icon: require('@/assets/img/workbench/审批管理.png'),
          path: `${callBackUrl}//auditManagement/requirement`,
          authCode: '/auditManagement/requirement',
          disabled: true,
          checked: true,
        },
      ],
      taskDataList: [
        {
          name: '审批任务',
          chidrenData: [
            {
              desc: '',
              width: '102px',
              list: [
                {
                  name: '待审批需求计划',
                  count: 0,
                  path: `${callBackUrl}/auditManagement/demand`,
                  authCode: '/auditManagement/demand',
                },
                {
                  name: '待审批采购方式',
                  count: 0,
                  path: `${callBackUrl}/auditManagement/procurementPlan`,
                  authCode: '/auditManagement/procurementPlan',
                },
                {
                  name: '待审批询价书',
                  count: 0,
                  path: `${callBackUrl}/auditManagement/enquiry`,
                  authCode: '/auditManagement/enquiry',
                },
                {
                  name: '待审批订单',
                  count: 0,
                  path: `${callBackUrl}/auditManagement/orderAudit`,
                  authCode: '/auditManagement/orderAudit',
                },
              ],
            },
          ],
        },
        {
          name: '采购计划任务',
          chidrenData: [
            {
              width: '105px',
              desc: '采购计划',
              list: [
                {
                  name: '待编制采购计划',
                  count: 0,
                  path: `${callBackUrl}/plan/purchaseWayEdit`,
                  authCode: '/plan/purchaseWayEdit',
                },
                {
                  name: '待执行采购计划',
                  count: 0,
                  path: `${callBackUrl}/plan/purchaseWayExecute`,
                  authCode: '/plan/purchaseWayExecute',
                },
              ],
            },
            {
              desc: `询价`,
              width: '75px',
              list: [
                {
                  name: '待揭示询价',
                  count: 0,
                  path: `${callBackUrl}/enquiryManage/enquiry`,
                  authCode: '/enquiryManage/enquiry',
                },
                {
                  name: '待定价询价',
                  count: 0,
                  path: `${callBackUrl}/enquiryManage/enquiry`,
                  authCode: '/enquiryManage/enquiry',
                },
                {
                  name: '待下单询价',
                  count: 0,
                  money: 0,
                  path: `${callBackUrl}/enquiryManage/enquiry`,
                  authCode: '/enquiryManage/enquiry',
                },
              ],
            },
            {
              desc: '招标',
              width: '105px',
              list: [
                {
                  name: '待编制招标方案',
                  count: 0,
                  path: `${bidSysBaseUrl}/bidding/preparationScheme`,
                  authCode: '/bidding/preparationScheme',
                },
                {
                  name: '待发布招标公告',
                  count: 0,
                  path: `${bidSysBaseUrl}/#/bidding/tenderNotice`,
                  authCode: '/bidding/tenderNotice',
                },
                {
                  name: '待开标项目',
                  count: 0,
                  path: `${bidSysBaseUrl}/#/biddingSpecific`,
                  authCode: '/biddingSpecific',
                },
                {
                  name: '待编制定标结果',
                  count: 0,
                  path: `${bidSysBaseUrl}/#/calibrationManagement/prepareCalibration`,
                  authCode: '/calibrationManagement/prepareCalibration',
                },
              ],
            },
            {
              desc: '协议',
              width: '75px',
              list: [
                {
                  name: '待确认协议',
                  count: 0,
                  path: `${yyhtUrl}/#/agreementManage`,
                  // authCode: 'https://yyzx.epec.com/#/agreementManage'
                  authCode: '/agreementManage',
                },
              ],
            },
            {
              desc: '订单',
              width: '75px',
              list: [
                {
                  name: '待确认订单',
                  count: 0,
                  path: `${purchaseUrl}/user/user/userOrder?type=18`,
                  authCode: '/user/user/userOrder',
                },
                {
                  name: '待收货订单',
                  count: 0,
                  path: `${purchaseUrl}/user/user/userOrder?type=4`,
                  authCode: '/user/user/userOrder',
                },
                {
                  name: '待付款订单',
                  count: 0,
                  path: `${purchaseUrl}/user/user/userOrder?type=21`,
                  authCode: '/user/user/userOrder',
                },
                {
                  name: '待评价订单',
                  count: 0,
                  path: `${purchaseUrl}/user/user/userOrder?type=5`,
                  authCode: '/user/user/userOrder',
                },
              ],
            },
            {
              desc: '异常订单',
              width: '75px',
              list: [
                {
                  name: '需确认订单',
                  count: 0,
                  path: `${epecMallUrl}/orderRecheck/recheckList`,
                  authCode: '/user/user/userOrder',
                },
                {
                  name: '已确认订单',
                  count: 0,
                  path: `${epecMallUrl}/orderRecheck/recheckList`,
                  authCode: '/user/user/userOrder',
                },
              ],
            },
          ],
        },
      ],
      menuList: [],
      sellMall: {},
      finalData: [],
    };
  },
  actions: {},

  head() {
    return {};
  },
  computed: {
    taskBarMenuList() {
      // if(process.env.NODE_ENV === 'production'){
      //   this.taskMenuList[6].path = 'https://mall.epec.com/ecmall/externalLogin/loginPlatform.do?referer=https://bidding.epec.com';
      //   this.taskMenuList[6].authCode = 'https://mall.epec.com/ecmall/externalLogin/loginPlatform.do?referer=https://bidding.epec.com';
      //  }else{
      //   this.taskMenuList[6].path = 'https://uat-mall.epec.com/ecmall/externalLogin/loginPlatform.do?referer=https://10.230.196.49';
      //   this.taskMenuList[6].authCode = 'https://uat-mall.epec.com/ecmall/externalLogin/loginPlatform.do?referer=https://10.230.196.49';
      // }


      this.taskMenuList.forEach((item) => {
        if (this.menuList.includes(item.authCode)) {
          item.checked = true;
          item.disabled = false;
        } else {
          item.checked = false;
          item.disabled = true;
        }
      });
      return this.taskMenuList;
    },
    mall_isLogin() {
      return this.$store.state.isLogin;
    },
    /* taskBarDataList() {
      this.taskDataList.forEach(item => {
        let childList = item.chidrenData;
        childList.forEach(list => {
          let childList1 = list.list;
          childList1.forEach(list1 => {
            if (this.menuList.includes(list1.authCode)) {
              list1.count = list1.count;
            } else {
              list1.count = 0;
            }
          });
        });
      });
      return this.taskDataList;
    }, */
  },
  watch: {
    mall_isLogin: {
      immediate: true,
      handler(newval) {
        if (newval) {
          const token = this.$cookies.get('epecToken');
          if (token) {
            // this.getPcMenuTree()
            this.initData();
          }
        }
      },
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    getFinalData() {
      const finalList = [];
      this.taskDataList.forEach((item) => {
        const childList = item.chidrenData;
        childList.forEach((list) => {
          const childList1 = list.list;
          childList1.forEach((list1) => {
            if (this.menuList.includes(list1.authCode)) {
              list1.count = list1.count;
            } else {
              list1.count = 0;
            }
          });
        });
      });
      this.finalData = [...this.taskDataList];
    },
    async getPcMenuTree() {
      const res = await Api.memberMenuTree();

      const nanJingWhiteData = localStorage.getItem('nanJingWhiteData');

      if (res.code == 200) {
        let list = [];
        const menu1 = res.data.biddingTreeVo.childList
          ? res.data.biddingTreeVo.childList
          : [];

        let menu2 = [];
        if (res.data.purchaseAreaTreeVo.childList) {
          if (nanJingWhiteData) {
            menu2 = res.data.purchaseAreaTreeVo.childList;
          } else {//没配置南京白名单，剔除
            const purchaseAreaTreeVo = whiteUtils.dealNanJingWhite(res.data.purchaseAreaTreeVo);
            menu2 = purchaseAreaTreeVo.childList;
          }
        }

        list = list.concat(menu1, menu2);
        if (menu1.length > 0) {
          this.menuList.push('/bidding/preparationScheme');
        }
        this.getAuthCode(list);
        this.getFinalData();
      }
    },
    initData() {
      const list = [
        this.getAgreementList(), // 待确认协议
        this.purchasePlanStatistical(),
        this.queryCountWaitApprove(),
        this.orderPurchaseCountStatistical(),
        this.enquiryPurchaseCountStatistical(),
        this.purchasePlanTenderingStatistical(),
        this.queryBrushingOrderCount(),
      ];
      Promise.all(list).then(() => {
        this.getPcMenuTree();
      });
    },
    getAuthCode(list) {
      list.map((item) => {
        if (item.authCode || item.authCode == '') {
          this.menuList.push(item.authCode);
          if (item.childList) {
            this.getAuthCode(item.childList);
          }
        }
      });
    },
    toPath(val, index) {
      if (index == 1) {
        window.open(val.path, '_blank');
      } else if (index == 2) {
        if (val.count) {
          window.open(val.path, '_blank');
        }
      }
    },
    getAgreementList() {
      const params = {
        agreementCode: '',
        agreementName: '',
        supplierCompanyName: '',
        externalStatus: 6,
        firstParty: '',
        sourcePlatform: '',
        pageSize: 100,
        pageNum: 1,
      };
      Api.getAgreementListForPurchase(params)
        .then((res) => {
          this.taskDataList[1].chidrenData[3].list[0].count = res.data.total;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async purchasePlanStatistical() {
      const res = await Api.purchasePlanStatistical({});
      if (res.data) {
        this.taskDataList[1].chidrenData[0].list[0].count =
          res.data.waitCreateDemandCount;
        this.taskDataList[1].chidrenData[0].list[1].count =
          res.data.waitExecutePlanCount;
      }
      // waitCreateDemandCount	待编制需求计划
      // waitExecutePlanCount	待执行采购方式
    },
    async queryCountWaitApprove() {
      const res = await Api.queryCountWaitApprove({});
      if (res.data) {
        this.taskDataList[0].chidrenData[0].list[0].count =
          res.data.waitApproveDemandCount;
        this.taskDataList[0].chidrenData[0].list[1].count =
          res.data.waitApprovePlanCount;
        this.taskDataList[0].chidrenData[0].list[2].count =
          res.data.waitApproveEnquiryCount;
        // this.taskDataList[0].chidrenData[0].list[3].count=res.data.waitApproveOrderCount
      }
      // 待审批需求计划  waitApproveDemandCount
      // 待审批采购计划  waitApprovePlanCount
      // 待审批询价书  waitApproveEnquiryCount
    },
    // 采购方式任务订单数量统计
    async orderPurchaseCountStatistical() {
      const res = await Api.orderPurchaseCountStatistical({});
      // waitConfirmOrderCount  待确认订单
      // waitEvaluationOrderCount 待评价订单
      // waitPaymentOrderCount  待付款订单
      // waitReceivingOrderCount 待收货订单
      // 待审批订单 waitApproveOrderCount
      if (res.data) {
        this.taskDataList[1].chidrenData[4].list[0].count =
          res.data.waitConfirmOrderCount;
        this.taskDataList[1].chidrenData[4].list[1].count =
          res.data.waitReceivingOrderCount;
        this.taskDataList[1].chidrenData[4].list[2].count =
          res.data.waitPaymentOrderCount;
        this.taskDataList[1].chidrenData[4].list[3].count =
          res.data.waitEvaluationOrderCount;
        this.taskDataList[0].chidrenData[0].list[3].count =
          res.data.waitApproveOrderCount;
      }
    },
    // 采购方式任务询价统计
    async enquiryPurchaseCountStatistical() {
      const res = await Api.enquiryPurchaseCountStatistical({});
      // waitRevealEnquiryCount	 待揭示询价单
      // waitPricingEnquiryCount	待定价询价
      // waitOrderEnquiryCount	待下单询价
      if (res.data) {
        this.taskDataList[1].chidrenData[1].list[0].count =
          res.data.waitRevealEnquiryCount;
        this.taskDataList[1].chidrenData[1].list[1].count =
          res.data.waitPricingEnquiryCount;
        this.taskDataList[1].chidrenData[1].list[2].count =
          res.data.waitOrderEnquiryCount;
        this.taskDataList[1].chidrenData[1].list[2].money =
          res.data.waitSubmitOrderAmount;
      }
    },
    async purchasePlanTenderingStatistical() {
      const res = await Api.purchasePlanTenderingStatistical({});
      if (res.data) {
        this.taskDataList[1].chidrenData[2].list[0].count =
          res.data.waitPreparedTendering;
        this.taskDataList[1].chidrenData[2].list[1].count =
          res.data.waitPublishTendering;
        this.taskDataList[1].chidrenData[2].list[2].count =
          res.data.waitOpeningBidding;
        this.taskDataList[1].chidrenData[2].list[3].count =
          res.data.waitCreatePurchase;
      }
      // waitCreatePurchase	待编制定标结果
      // waitOpeningBidding	待开标项目
      // waitPublishTendering //待发布招标方案
      // waitPreparedTendering //待编制招标方案
    },

    // 获得异常订单的数量
    async queryBrushingOrderCount() {
      const res = await Api.queryBrushingOrderCount({});
      console.log(res);
      if (res.data) {
        this.taskDataList[1].chidrenData[5].list[0].count =
          res.data.waitConfirmCount;
        this.taskDataList[1].chidrenData[5].list[1].count =
          res.data.confirmedCount;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.taskbar {
  border: 1px solid #dcdcdc;
  margin-top: 20px;
  background: #fff;
  .taskbar_header {
    height: 44px;
    background: #f5f5f5;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    border-bottom: 1px solid #d9d9d9;
    img {
      cursor: pointer;
    }
    .title {
      font-size: 14px;
      display: flex;
      align-items: center;
      background: #f5f5f5;
      color: #333;
      .text {
        margin-left: 10px;
      }
    }
  }
  .task_menu {
    padding: 20px;
    .task_icon {
      width: 54px;
      height: 54px;
      background: #f5f5f5;
      line-height: 54px;
      text-align: center;
      border-radius: 50%;

      img {
        vertical-align: middle;
      }
    }
    .task_item {
      display: flex;
      flex-flow: column;
      align-items: center;
      cursor: pointer;
      margin-right: 20px;
      p {
        font-size: 14px;
        color: #333333;
        margin-top: 10px;
      }
      p:hover {
        color: $main-col;
      }
    }
  }
  .task_data {
    padding: 20px;
    width: 1200px;
    .task_title {
      font-size: 14px;
      line-height: 14px;
      font-weight: 600;
      color: #333333;
      margin-bottom: 20px;
    }
    .data_item {
      position: relative;
      margin-right: 44px;
    }
    .item_end {
      margin-right: 0px;
    }
    .item_end:after {
      display: none;
    }
    .data_item:after {
      content: '';
      display: inline-block;
      width: 1px;
      background: #dcdcdc;
      height: 100%;
      position: absolute;
      top: 0;
      right: -22px;
    }
    .task_data_item {
      position: relative;
      margin-right: 44px;
      min-width: 110px;
      .task_desc {
        margin-bottom: 20px;
        color: #333333;
        font-size: 14px;
        line-height: 14px;

        text-align: left;
      }
      .task_list {
        margin-bottom: 20px;
        color: #666666;
        font-size: 14px;
        line-height: 14px;
        .name {
          display: inline-block;
          width: 105px;
          text-align: right;
        }
        .count {
          color: $main-col;
          font-weight: 600;
          margin-left: 5px;
          cursor: pointer;
          //width: 22px;
          display: inline-block;
        }
        .count:hover {
          text-decoration: underline;
        }
        .count_none {
          font-weight: 600;
          margin-left: 5px;
          //width: 22px;
          display: inline-block;
        }
      }
    }
    .task_data_item_box:after {
      content: '';
      display: inline-block;
      width: 1px;
      background: #dcdcdc;
      height: 100%;
      position: absolute;
      top: 0;
      right: -22px;
    }
    .task_data_item_end {
      margin-right: 0px;
    }
  }
}
</style>
